import { ItemView, util } from '@glu/core';
import dialog from '@glu/dialog';
import AdvancedSearch from './advancedSearch';
import template from './manageFiltersLink.hbs';

export default ItemView.extend({
  template,
  tagName: 'ul',
  className: 'item-list grid-manage-filters-link',

  events: {
    click: 'showAdvancedSearch'
  },

  initialize() {
    this.grid = this.options.grid;

    this.advancedFilterView = new AdvancedSearch({
      collection: this.collection,
      filterViewClass: this.options.filterViewClass,
      columns: this.options.columns,
      grid: this.grid,
      filterProc: this.options.filterProc
    });
    this.listenTo(this.advancedFilterView, 'submit', this.handleAdvancedFilterSubmit);
  },

  showAdvancedSearch(e) {
    e.preventDefault();
    util.defer(() => {
      if (this.isClosed) {
        return;
      }
      // need to close opened flexDropdown.
      this.appBus.trigger('open.dropdown');

      dialog.open(this.advancedFilterView);
      this.grid.trigger('filter:advanced', this.advancedFilterView);
    });
  },

  onClose() {
    // This is made and sometimes shown in a dialog, but no one ever closes the thing!
    if (this.advancedFilterView) {
      this.advancedFilterView.close();
    }
  },

  handleAdvancedFilterSubmit(evt) {
    this.grid.trigger('filter:advanced:submit', evt);
  }
});
